import * as React from "react";

import { cn } from "@/lib/utils";
import { EmptyState } from "@/components/ui/empty-state";

/**
 * Phase 10B 2050 DataCard
 * - Frosted card-2050 surface, 14px radius, hover lift
 * - Compact title row with optional actions on the right
 * - Skeleton + EmptyState built in
 */
const DataCard = React.forwardRef(
  (
    {
      className,
      title,
      description,
      actions,
      loading = false,
      empty = false,
      emptyTitle = "No data yet",
      emptyDescription = "Data will appear once it flows through.",
      emptyIcon,
      children,
      bodyClassName,
      headerClassName,
      ...props
    },
    ref
  ) => {
    const showEmpty = empty && !loading;
    return (
      <div
        ref={ref}
        className={cn("card-2050 overflow-hidden focus-2050", className)}
        {...props}
      >
        {(title || description || actions) && (
          <div
            className={cn(
              "flex items-start justify-between gap-4 px-6 py-4 border-b border-ink-200/60 dark:border-ink-800/60",
              headerClassName
            )}
          >
            <div className="min-w-0">
              {title && (
                <div className="text-sm font-semibold tracking-tight truncate">
                  {title}
                </div>
              )}
              {description && (
                <div className="mt-0.5 text-xs text-ink-500">
                  {description}
                </div>
              )}
            </div>
            {actions && (
              <div className="flex items-center gap-2 flex-shrink-0">
                {actions}
              </div>
            )}
          </div>
        )}
        <div className={cn("p-6", bodyClassName)}>
          {loading ? (
            <div className="space-y-3">
              <div className="h-4 w-1/3 skeleton" />
              <div className="h-4 w-2/3 skeleton" />
              <div className="h-4 w-1/2 skeleton" />
            </div>
          ) : showEmpty ? (
            <EmptyState
              title={emptyTitle}
              description={emptyDescription}
              icon={emptyIcon}
            />
          ) : (
            children
          )}
        </div>
      </div>
    );
  }
);
DataCard.displayName = "DataCard";

export { DataCard };
